/**
 * Probability display contract: always a whole-number percentage (e.g. `60%`).
 * API values are 0–1 fractions; never show raw decimals in the UI.
 */

/** Parse a 0–1 fraction (or already 0–100 if > 1) into a clamped percent integer. */
export function probabilityToPercent(value: number | string | null | undefined): number | null {
  if (value == null || value === '') return null
  const numeric = typeof value === 'string' ? Number(value) : value
  if (!Number.isFinite(numeric)) return null
  // Treat values > 1 as already-percent (admin typos / legacy).
  const pct = numeric > 1 ? numeric : numeric * 100
  return Math.round(Math.min(100, Math.max(0, pct)))
}

/** Format for display — `60%` or em dash. */
export function formatProbability(value: number | string | null | undefined): string {
  const pct = probabilityToPercent(value)
  return pct == null ? '—' : `${pct}%`
}

/** Convert a percent integer (0–100) to the API fraction (0–1). */
export function percentToProbability(percent: number | string | null | undefined): number {
  if (percent == null || percent === '') return 0
  const numeric = typeof percent === 'string' ? Number(percent) : percent
  if (!Number.isFinite(numeric)) return 0
  return Math.min(1, Math.max(0, numeric / 100))
}
